import styled from '@emotion/styled'

export const StyleMapInputWrapper = styled.div<any>`
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props?.disabled ? 'not-allowed' : 'pointer')};
  justify-content: space-between;
  padding: 0px 10px;
  background: #fff;
  ${(props: any) => props.styleInput};
`
